import dayjs from 'dayjs';
import { TIMEZONE_VN } from 'constant';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

export const get12hOfDate = (date) => {
  if (!date) return null;
  // eslint-disable-next-line newline-per-chained-call
  return dayjs(date).hour(12).minute(0).second(0).millisecond(0);
};

export const formatDatetime = (date, template, tz = TIMEZONE_VN) => {
  if (!date || !dayjs(date).isValid()) return '';

  const utcDate = dayjs(date).isUTC() ? dayjs(date) : dayjs.utc(date);
  return utcDate.tz(tz).format(template);
};

export default {
  get12hOfDate,
};
